import { Component, OnInit, Inject } from '@angular/core';
import { BasketService } from '../../shared/services/basket.service';
import { AccountService } from '../../shared/services/account.service';
import { AppService } from '../../shared/services/app.service';
import { Router } from '@angular/router';
import { LanguageService } from '../../shared/services/language.service';
import { LocalstorageService } from '../../shared/services/localstorage.service';
import { DOCUMENT } from '@angular/common';

declare var $: any; import {isBrowser} from '../../shared/thirdparty/isBrowser'
import { TranslateService } from '@ngx-translate/core';
import { CardConfig } from 'src/app/shared/components/tarifs-card/tarifs-card.component';
declare var Swal:any;

@Component({
    selector: 'app-tarifs',
    templateUrl: './tarifs.component.html',
    styleUrls: ['./tarifs.component.scss']
})
export class TarifsComponent implements OnInit {

    public loading = true
    public prices:any = {}
    public subscriptions:any = null
    public test = "Animation Journée sécurité"
    public mouseOvered = false

    constructor(
        public router: Router,
        public accountService : AccountService,
        public appService : AppService,
        public basketService : BasketService,
        public language : LanguageService,
        public localStorage : LocalstorageService,
        public translate: TranslateService,
        @Inject(DOCUMENT) public document: Document
    ) {}

    priceCards: CardConfig[] = [
        {
            title: 'SafetyBox _vr_icon_ <sup>©</sup>',
			color: '#dc9599',
			price: 3990,
			priceAsterisk: '**',
			img: {
                name: 'Tarifs_SafetyBox',
				alt: 'SafetyBoxVR',
			},
            description: 'Vous êtes une <b>entreprise</b> ou un groupe, nous vous mettons à disposition un casque VR prêt à l’emploi pendant 1 an. Vous utilisez toute l’année l’accès aux exercices pour vos formations, animations, ...',
            dots:[
                {text: 'Un casque VR pendant 1 an, livré chez vous', infoIconAction: ()=>{ this.router.navigate(this.language.navigateAccordingToLang(['/content'])) }},
                {text: 'Tous les exercices préinstallés'},
                {text: 'Passages illimités de tous vos salariés'},
                {text: 'Notices d’utilisation, support personnalisé'},
                {text: 'Aide à la prise en main à distance et solution MDM installée'},
            ],
            mainButton: {
                action: ()=>{ this.router.navigate(this.language.navigateAccordingToLang(['/about-us/o']), { state: {'prefillContact' : 'SafetyBox VR'}}) },
                text: 'Contact us'
            },
            yellowText:{
                text: this.translate.instant('Vous souhaitez tester en journée sécurité ?'),
                route: '/safety-day',
                title: 'test on a safety day'
            },
            learnMore: {
                action: () =>{ this.router.navigate(this.language.navigateAccordingToLang(['/safetybox-vr'])) }
            },
		},
		{
			title: this.translate.instant('Subscription') + ' _vr_icon_',
			price: 3700,
			priceAsterisk: '*',
			img: {
				name: 'subscription-vr-metaquest',
				alt: 'Subscription VR',
			},
            description: 'Vous êtes une <b>entreprise</b> ou un groupe équipé d’un casque de VR ou d’un PC, vous utilisez toute l’année l’accès aux exercices pour vos formations, animations, ..., vous mettez vos salariés en situation',
            dots: [
                {text: 'Accès offline aux exercices', infoIconAction: ()=>{ this.router.navigate(this.language.navigateAccordingToLang(['/content'])) }},
                {text: 'Passages illimités sur un poste pendant 1 an'},
                {text: 'Rapports anonymes horodatés'},
                {text: 'Pour Vive Focus, Pico Neo, Meta Quest ou PC'},
                {text: 'Support, maintenance et mises à jour régulières'},
            ],
            mainButton: {
                action: ()=>{ this.subscribe('workshops') }
            },
            yellowText:{
                text: 'Vous souhaitez des licences illimitées entreprises ?',
                route: '/about-us/o',
                title: 'unlimited business licenses',
                state: {'prefillContact' : this.translate.instant('Abonnement annuel')}
            },
            learnMore: {
                action: ()=>{ this.router.navigate(this.language.navigateAccordingToLang(['/content'])) }
            },
		},
		{
			title: this.translate.instant('Abonnement')+' _ar_icon_',
			price: 3000,
			priceAsterisk: '*',
			img: {
				name: 'senar_tablet',
				alt: 'Senar demo with tablet',
			},
            description: 'Vous êtes une <b>entreprise</b> ou un groupe, vous utilisez toute l’année l’accès aux exercices pour vos formations, animations, ..., vous mettez vos salariés en situation',
            dots:[
                {text: "Accès aux collections Senar"},
                {text: "Passages illimités sur mobile pendant 1 an"},
                {text: "Rapports anonymes horodatés"},
                {text: "Pour Mobile et Tablette"},
                {text: "Support, maintenance et mises à jour régulières"},
            ],
            mainButton: {
                action: ()=>{ this.router.navigate(this.language.navigateAccordingToLang(['/about-us/o']), { state: {'prefillContact' : this.translate.instant('Informations Abonnement AR')}}) },
                text: 'Contact us'
            },
            yellowText:{
                text: 'Vous souhaitez effectuer un essai gratuit ?',
                route: '/about-us/o',
                title: 'free demo',
                state: {'prefillContact' : this.translate.instant('Démo Abonnement AR')}
            },
            learnMore: {
                action: ()=>{ this.router.navigate(this.language.navigateAccordingToLang(['/about-us/o']), { state: {'prefillContact' : this.translate.instant('Informations Abonnement AR')}}) },
            },
		},
        {
			title: this.translate.instant('I-learning'),
            priceText: "Modulable",
			img: {
				name: 'tarifs-abonnement-i-learning',
				alt: 'I-Learning subsription',
			},
            description: 'Vous êtes une <b>entreprise</b> ou un groupe et vous souhaitez former également à distance en utilisant nos solutions Immersive Learning déployables sur ordinateurs, tablettes et mobiles',
            dots:[
                {text: 'Accès online aux contenus immersifs'},
                {text: 'Accès uniques ou simultanés'},
                {text: 'Compatible LMS et Scorm'},
                {text: 'Pour PC, Mac, Mobile et Tablette'},
                {text: 'Support, maintenance et mises à jour régulières'},
            ],
            mainButton: {
                action: ()=>{ this.router.navigate(this.language.navigateAccordingToLang(['/about-us/o']), { state: {'prefillContact' : this.translate.instant('I-Learning')}}) },
                text: 'Contact us'
            },
            yellowText:{
                text: 'Vous souhaitez essayer un extrait gratuit en ligne ?',
                route: '/demo',
                title: 'free demo'
            },
            learnMore: {
                action: ()=>{ this.router.navigate(this.language.navigateAccordingToLang(['/demo'])) }
            },
		}
	];

    ngOnInit() {
        this.refreshPrices()
    }

    refreshPrices(){
        this.loading = true
        return this.basketService.getPrices()
        .then((prices)=>{
            this.loading = false
            this.prices = prices
            console.log(prices.workshops_annual)
            this.priceCards[0].price = prices.workshops_annual
        })
    }

    freeAccess(){
        this.router.navigate(this.language.navigateAccordingToLang(['/demo']))
    }

    subscribe(type){
        if(type == 'campus'){
            this.localStorage.setItem('basket', JSON.stringify({
                items:[
                    {type:'campus', period:'annual', quantity:10},
                    {type:'users_subscription', period:'annual', quantity:100}
                ]
            }))
            this.router.navigate(this.language.navigateAccordingToLang(['/basket']))
        }
        else if(type == 'workshops'){
            this.localStorage.setItem('basket', JSON.stringify({
                items:[
                    {type:'workshops', period:'annual'}
                ]
            }))
            this.router.navigate(this.language.navigateAccordingToLang(['/basket']))
        }
        else if(type == 'workshop'){
            this.router.navigate(this.language.navigateAccordingToLang(['/content']))
        }
        else if(type == 'safety_day'){
            this.router.navigate(this.language.navigateAccordingToLang(['/our-contributors']))
        }
        else if(type == 'trainer_campus'){
            this.localStorage.setItem('basket', JSON.stringify({
                items:[
                    {type:'trainer_campus', period:'daily', quantity:1, referenceId:10, referenceId2:'VR'}
                ]
            }))
            this.router.navigate(this.language.navigateAccordingToLang(['/basket']))
        }
    }

}
